import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getStockAnalysis,
  getParticularPage,
  getNext,
  getPrevious,
  // filter by stockAnalysis id
  getStockAnalysisByItem,
  handleSearch,
} from "./thunk";

const initialState = {
  stockAnalysiss: [],
  edit: false,
  stockAnalysis: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingStockAnalysis: false,
  loadingNext: false,
};

export const stockAnalysisSlice = createSlice({
  name: "stockAnalysis",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllStockAnalysis: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingStockAnalysis = false;
      state.stockAnalysis = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStockAnalysisByItem.pending, (state) => {
      state.stockAnalysis = null;
      state.edit = true;
    });
    builder.addCase(getStockAnalysisByItem.fulfilled, (state, action) => {
      state.stockAnalysis = action.payload;
    });

    builder.addCase(getStockAnalysisByItem.rejected, (state) => {
      state.stockAnalysis = null;
      state.edit = false;
    });

    builder.addMatcher(
      isAnyOf(
        getStockAnalysis.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingStockAnalysis = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getStockAnalysis.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingStockAnalysis = false;
        state.stockAnalysiss = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getStockAnalysis.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingStockAnalysis = false;
      }
    );
  },
});

export const { goToPage, clearAllStockAnalysis } = stockAnalysisSlice.actions;

export default stockAnalysisSlice.reducer;
